module.exports = __webpack_public_path__ + "fonts/MaterialIconsRound-Regular.3422ceae.otf";